import { render, staticRenderFns } from "./videopreview.vue?vue&type=template&id=a59da0f8&scoped=true"
import script from "./videopreview.vue?vue&type=script&lang=js"
export * from "./videopreview.vue?vue&type=script&lang=js"
import style0 from "./videopreview.vue?vue&type=style&index=0&id=a59da0f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a59da0f8",
  null
  
)

export default component.exports